// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `'General Sans', sans-serif`,
  },
});

export default theme;
